import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import IotDiagnosisVBeltReportDataroomMaintenenceReport from "./iot-diagnosis-vbelt-report";
import IotDiagnosisVibrationReportDataroomMaintenenceReport from "./iot-diagnosis-vibration-report";
import IotDiagnosisNoiseReportDataroomMaintenenceReport from "./iot-diagnosis-noise-report";
import IotDiagnosisTemperatureReportDataroomMaintenenceReport from "./iot-diagnosis-temperature-report";
import IotDiagnosisChainReportDataroomMaintenenceReport from "./iot-diagnosis-chain-report";

const IotDiagnosisReportReportDataroomMaintenenceReport = () => {
    const { t } = useTranslation();
    const types = [{code:"V",title:t('message.common.select.vibration')}, {code:"N",title:t('message.common.select.noise')}, {code:"B",title:t('message.common.select.vbelt')}
        , {code:"C",title:t('message.common.select.chain')}, {code:"T",title:t('message.common.subtitle.equipment.temperature')}
    ];
    const [searchTypeCode, setSearchTypeCode] = useState({code:"V",title:t('message.common.select.vibration')});
    const [isContentsView, setIsContentsView] = useState([false,false,false,false,false]);

    useEffect(()=>{
        if (searchTypeCode === null || searchTypeCode === '') {
            setIsContentsView([false,false]);
            return;
        } else {
            if (searchTypeCode.code === 'V') {
                setIsContentsView([true,false,false,false,false]);
            } else if (searchTypeCode.code === 'N') {
                setIsContentsView([false,true,false,false,false]);
            } else if (searchTypeCode.code === 'B') {
                setIsContentsView([false,false,true,false,false]);
            } else if (searchTypeCode.code === 'C') {
                setIsContentsView([false,false,false,true,false]);
            } else if (searchTypeCode.code === 'T') {
                setIsContentsView([false,false,false,false,true]);
            }
        }
    },[searchTypeCode])

    return (
        <div style={{color:"#000"}}>
            <div className="report-dataroom">
                <div className="report-dataroom-left">
                    <ul>
                        <li>{t('message.common.select.division')}</li>
                        {types && types.map(function(param,i) {
                            let boldStyle = "";
                            if (param.code === searchTypeCode.code)
                                boldStyle = "bold";
                            return (
                        <li key={i} style={{fontWeight:`${boldStyle}`}}><Link onClick={()=>{setSearchTypeCode(param)}}>{param.title}</Link></li>        
                            )
                        })}
                    </ul>
                </div>

                <div className="report-dataroom-right">
                    {isContentsView[0] && <IotDiagnosisVibrationReportDataroomMaintenenceReport />}
                    {isContentsView[1] && <IotDiagnosisNoiseReportDataroomMaintenenceReport />}
                    {isContentsView[2] && <IotDiagnosisVBeltReportDataroomMaintenenceReport />}
                    {isContentsView[3] && <IotDiagnosisChainReportDataroomMaintenenceReport />}
                    {isContentsView[4] && <IotDiagnosisTemperatureReportDataroomMaintenenceReport />}
                </div>
            </div>
        </div>
    )
}

export default IotDiagnosisReportReportDataroomMaintenenceReport;